export default __webpack_public_path__ + "17470613dd9326b4f7428aa41a0b2f4a.jpg";